/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeDRadiusDownRightIcon16Solid = forwardRef('ArrowShapeDRadiusDownRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 14.017c0 .847 1.024 1.27 1.622.672l5.805-5.805a1.25 1.25 0 0 0 0-1.768L9.622 1.311C9.024.713 8 1.137 8 1.983v2.758c-1.41-.033-2.279-.176-2.996-.504-.83-.381-1.543-1.051-2.643-2.368a.75.75 0 0 0-1.324.428c-.225 3.159.586 5.435 2.095 6.916 1.314 1.289 3.066 1.885 4.868 2.01v2.794Z" })));
});
